import { render, staticRenderFns } from "./CustomPointInfo.vue?vue&type=template&id=b4599ece&scoped=true"
import script from "./CustomPointInfo.vue?vue&type=script&lang=js"
export * from "./CustomPointInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4599ece",
  null
  
)

export default component.exports